import base from '../dr-base'
import drExpansionPanel from './dr-expansion-panel.vue'

const schema = {
  $Type: 'dr-expansion-panel-item',
  name: 'Panel item',
  group: 'Container widgets',
  allowInToolbox: false,
  properties: {
    ...base.properties,
    Widgets: {
      type: 'array',
      items: {
        type: 'object'
      }
    },
    Text: {
      name: 'vuetifyWidgets.dr-expansion-panel.text',
      type: 'string',
      default: ''
    },
    IconName: {
      name: 'vuetifyWidgets.dr-expansion-panel.iconName',
      type: 'string',
      default: '',
      component: 'dr-icon-picker'
    },
    IconColor: {
      name: 'vuetifyWidgets.dr-expansion-panel.iconColor',
      type: 'string',
      default: '#2196f3',
      component: 'dr-color-picker'
    }
  }
}

export default {
  schema,
  component: drExpansionPanel,
  propEditors: [
    {
      name: 'dr-icon-picker'
    },
    {
      name: 'dr-color-picker'
    }
  ]
}
